import React from 'react'
import { ArrowLeft, Save, FileText, Loader2 } from 'lucide-react'
import { Button } from '../../../../components/ui'
import { Lead } from '../../../../types'
import { LeadEditFormData } from '../../domain/interfaces'

interface LeadEditHeaderProps {
 lead: Lead | null
 formData: LeadEditFormData
 isSubmitting: boolean
 isCreating?: boolean
 onCancel: () => void
 onSubmit: () => Promise<{ success: boolean; message: string } | void>
 onCreateProposal: () => void
}

export const LeadEditHeader: React.FC<LeadEditHeaderProps> = ({
 lead,
 formData,
 isSubmitting,
 isCreating = false,
 onCancel,
 onSubmit,
 onCreateProposal
}) => {
 const handleSubmit = async () => {
 const result = await onSubmit()
 // Toast será gerenciado pelo componente pai
 return result
 }

 return (
 <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
 <div className="flex min-w-0 flex-1 flex-col gap-3 sm:flex-row sm:items-center sm:gap-4">
 <Button
 type="button"
 variant="outline"
 size="sm"
 onClick={onCancel}
 className="w-fit shrink-0"
 >
 <ArrowLeft className="h-4 w-4" />
 Voltar
 </Button>
 <div className="min-w-0">
 <h1 className="text-xl font-semibold tracking-tight text-foreground sm:text-2xl">
 {isCreating ? 'Criar Lead' : `Editar Lead${lead?.id ? ` #${lead.id.substring(0, 8)}` : ''}`}
 </h1>
 <p className="mt-1 text-sm text-muted-foreground">
 {isCreating 
 ? 'Crie um novo lead para acompanhar potenciais clientes'
 : 'Atualize os dados do lead e acompanhe o funil de vendas'}
 </p>
 </div>
 </div>

 {/* Botões de Ação */}
 <div className="flex shrink-0 flex-wrap items-center gap-2 sm:justify-end">
 {!isCreating && (
 <Button
 type="button"
 variant="outline"
 size="sm"
 onClick={onCreateProposal}
 disabled={!formData.vehicleInterests || formData.vehicleInterests.length === 0}
 title={
 !formData.vehicleInterests || formData.vehicleInterests.length === 0
 ? 'Adicione veículos de interesse primeiro'
 : 'Criar proposta para este lead'
 }
 className="w-fit"
 >
 <FileText className="h-4 w-4" />
 Criar Proposta
 </Button>
 )}
 <Button
 type="button"
 size="sm"
 onClick={handleSubmit}
 disabled={isSubmitting}
 className="w-fit"
 >
 {isSubmitting ? (
 <>
 <Loader2 className="h-4 w-4 animate-spin" />
 Salvando...
 </>
 ) : (
 <>
 <Save className="h-4 w-4" />
 Salvar Alterações
 </>
 )}
 </Button>
 </div>
 </div>
 )
}

